module.exports = __webpack_public_path__ + "img/arrow-up-right-square-fill.75fab2e1.svg";